import { render, staticRenderFns } from "./kamitakuAd.vue?vue&type=template&id=7ff6f4a8&scoped=true&"
import script from "./kamitakuAd.vue?vue&type=script&lang=js&"
export * from "./kamitakuAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff6f4a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff6f4a8')) {
      api.createRecord('7ff6f4a8', component.options)
    } else {
      api.reload('7ff6f4a8', component.options)
    }
    module.hot.accept("./kamitakuAd.vue?vue&type=template&id=7ff6f4a8&scoped=true&", function () {
      api.rerender('7ff6f4a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kamitaku/kamitakuAd.vue"
export default component.exports